// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cju0","rootMobile":"styles_rootMobile__2BHWe"};